module.exports = __webpack_public_path__ + "media/promo/hochland/images/footer-d0d4fa40d42dd548b7c8cd355769ba9a.png";